import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { University } from '../models/university/university';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';

@Injectable({ providedIn: 'root' })
export class CurrentUniversityService {
	currentUniversitySubject: BehaviorSubject<University | null>;
	currentUniversity: University | null;
	currentUniversityId: BehaviorSubject<string | null>;

	constructor(private _coreMenuService: CoreMenuService) {
		this.currentUniversitySubject = new BehaviorSubject<University | null>(null);
		this.currentUniversityId = new BehaviorSubject<string | null>(null);

		if (this.getUniversityFromStorage()) {
			this.currentUniversityId.next(String(this.getUniversityFromStorage()));
		}
	}

	changeUniversity(university: University, changeMenu: boolean = true) {
		sessionStorage.setItem('university', String(university.id));

		if (changeMenu && this._coreMenuService.menuKeyExist('university')) {
			this._coreMenuService.setCurrentMenu('university');
		}

		this.currentUniversity = university;
		this.currentUniversitySubject.next(university);
		this.currentUniversityId.next(university.id);
	}

	exitUniversity() {
		if (this._coreMenuService.menuKeyExist('main')) {
			this._coreMenuService.setCurrentMenu('main');
		}

		sessionStorage.removeItem('university');

		this.currentUniversity = null;
		this.currentUniversitySubject.next(null);
		this.currentUniversityId.next(null);
	}

	getUniversityFromStorage(): string | null {
		return sessionStorage.getItem('university');
	}
}
